<template>
  <div class="expressContainer">
    <van-popup
      v-model="show"
      closeable
      round
      position="bottom"
      :style="{ height: '70%' }"
    >
      <div class="expressTop">
        <!-- <div style="width: 50px; height: 50px">
          <img :src="steps.result.logo" alt />
        </div> -->

        <!-- <div id="title">运输中</div> -->
        <div class="flex">
          <div class="expressPhone">
            {{ steps.result.expName }} :
            <span class="fontWeight">{{ steps.result.number }}</span>
          </div>
          <span
            class="code expressPhone"
            :data-clipboard-text="steps.result.number"
            @click="copy"
            >复制</span
          >
          <!-- <van-icon
          name="eye-o"
          class="code"
          :data-clipboard-text="steps.result.number"
          @click="copy"
        /> -->
        </div>
        <div class="expressPhone">
          <span class="name">官方电话 : </span>
          <span class="fontWeight" @click="callPhone(steps.result.expPhone)">{{
            steps.result.expPhone
          }}</span>
        </div>
      </div>
      <div
        class="between"
        style="padding: 10px; border-bottom: 10px solid #f8f8f8"
      >
        <div class="flex">
          <!-- <div style="width: 30px; height: 30px;">
          <img :src="steps.result.logo" alt style="border-radius:50%;"/>
        </div> -->
          <div class="name">{{ steps.result.courier }} :</div>
        </div>

        <div
          class="callexpressName"
          @click="callPhone(steps.result.courierPhone)"
        >
          联系快递员
        </div>
      </div>
      <div class="stepsExpress">
        <van-steps direction="vertical" :active="active" active-color="#000">
          <van-step v-for="(item, index) in steps.result.list" :key="index">
            <template #active-icon v-if="steps.result.deliverystatus == '3'">
              <div class="collect">收</div>
            </template>
            <template #inactive-icon v-if="steps.result.deliverystatus == '1'">
              <van-icon name="logistics" />
            </template>

            <!--  <div v-if="steps.result.deliverystatus == '2'">正在派件</div>
            <div v-if="steps.result.deliverystatus == '1'">在途中</div>
            <div v-if="steps.result.deliverystatus == '0'">快递收件(揽件)</div> -->
            <p>
              {{ item.status }}
            </p>
            {{ item.time }}
            <!-- </div> -->
          </van-step>
        </van-steps>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  AddressList,
  Step,
  Steps,
  Tag,
  Cell,
  Icon,
  Toast,
  Dialog,
  Notify,
  Popup
} from "vant";
import service from "../../api/express";
import Clipboard from "clipboard";
export default {
  components: {
    [AddressList.name]: AddressList,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Tag.name]: Tag,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Notify.name]: Notify,
    [Popup.name]: Popup
  },
  data() {
    return {
      show: true,
      active: 0,
      steps: {
        status:
          "0" /* status 0:正常查询 201:快递单号错误 203:快递公司不存在 204:快递公司识别失败 205:没有信息 207:该单号被限制，错误单号 */,
        msg: "ok",
        result: {
          number: "780098068058",
          type: "zto",
          list: [
            {
              time: "2018-03-09 11:59:26",
              status:
                "【石家庄市】快件已在【长安三部】 签收,签收人: 本人,感谢使用中通快递,期待再次为您服务!"
            },
            {
              time: "2018-03-09 09:03:10",
              status:
                "【石家庄市】 快件已到达 【长安三部】（0311-85344265）,业务员 容晓光（13081105270） 正在第1次派件, 请保持电话畅通,并耐心等待"
            },
            {
              time: "2018-03-08 23:43:44",
              status: "【石家庄市】 快件离开 【石家庄】 发往 【长安三部】"
            },
            {
              time: "2018-03-08 21:00:44",
              status: "【石家庄市】 快件到达 【石家庄】"
            },
            {
              time: "2018-03-07 01:38:45",
              status: "【广州市】 快件离开 【广州中心】 发往 【石家庄】"
            },
            {
              time: "2018-03-07 01:36:53",
              status: "【广州市】 快件到达 【广州中心】"
            },
            {
              time: "2018-03-07 00:40:57",
              status: "【广州市】 快件离开 【广州花都】 发往 【石家庄中转】"
            },
            {
              time: "2018-03-07 00:01:55",
              status:
                "【广州市】 【广州花都】（020-37738523） 的 马溪 （18998345739） 已揽收"
            }
          ],
          deliverystatus:
            "3" /* 0：快递收件(揽件)1.在途中 2.正在派件 3.已签收 4.派送失败 5.疑难件 6.退件签收  */,
          issign: "1" /*  1.是否签收                  */,
          expName: "中通快递" /*  快递公司名称                */,
          expSite: "www.zto.com" /*  快递公司官网                */,
          expPhone: "95311" /*  快递公司电话                */,
          courier: "容晓光" /*  快递员 或 快递站(没有则为空)*/,
          courierPhone: "13081105270" /*  快递员电话 (没有则为空)     */,
          updateTime: "2019-08-27 13:56:19" /*  快递轨迹信息最新时间        */,
          takeTime: "2天20小时14分" /*  发货到收货消耗时长 (截止最新轨迹)  */,
          logo: "https://img3.fegine.com/express/zto.jpg" /* 快递公司LOGO */
        }
      },
      expressNo: 0
    };
  },
  methods: {
    copy() {
      var clipboard = new Clipboard(".code");
      clipboard.on("success", (e) => {
        Toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        Toast("手机权限不支持复制功能");
        // 释放内存
        clipboard.destroy();
      });
    },
    callPhone(phoneNumber) {
      Dialog.confirm({
        title: "标题",
        message: "是否拨打?"
      })
        .then(() => {
          // on confirm;
          window.location.href = "tel://" + phoneNumber;
        })
        .catch(() => {
          // on cancel
        });
    },
    getExpressInfo(expressAll) {
      var orderExpressLastTime = localStorage.getItem(
        "orderExpressLastTime-" + this.expressNo
      );
      if (
        orderExpressLastTime !== "" &&
        new Date().getTime() - orderExpressLastTime <= 28800000
      ) {
        this.steps = localStorage.getItem("orderExpress");
      } else {
        service
          .post({ no: "SF1351764553453", name: "顺丰快递" })
          .then((response) => {
            response.data = JSON.parse(response.data);
            console.log(response, 185);
            switch (response.data.status) {
              case "0":
                {
                  this.steps = response.data;
                  this.empty = false;
                  localStorage.setItem("orderExpress", response.data);
                  localStorage.setItem(
                    "orderExpressLastTime-" + this.expressNo,
                    new Date().getTime()
                  );
                }
                break;
              case "203":
                this.steps = response.data.result;
                break;
              case 205:
                this.empty = true;
                break;
              case "201":
                Notify({
                  type: "danger",
                  message: response.data.msg
                });
                break;
              case 204:
                break;
              case 207:
                break;
            }
          });
      }
    }
  },
  mounted() {
    // this.getExpressInfo(this.$route.query.expressAll);
  }
};
</script>
<style lang="less" scoped>
.expressContainer {
  background: #fff;
  .between {
    padding: 10px;
    border-bottom: 10px solid rgb(248, 248, 248);
    border-top: 1px solid #f8f8f8;
  }
}
.code {
  margin-left: 2vw;
}
.expressTop {
  padding: 4vw 3vw;
}
.stepsExpress {
  padding: 3vw;
}
.expressPhone {
  height: 7vw;
  line-height: 7vw;
  margin-right: 2vw;
}
.collect {
  background: #eb4545;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  font-weight: 600;
}
.callexpressName {
  border: 1px solid #999;
  padding: 4px 9px;
  border-radius: 13px;
}
</style>